export default import.meta.ROLLDOWN_FILE_URL_ccQLdLxs77C6vK88rAaGsw